import { combineReducers } from 'redux';
import entityReducer from './entityReducer';

export default {
  checklistItems: entityReducer('checklistItems'),
  uploadedFiles: entityReducer('uploadedFiles'),
  checklistAnswers: entityReducer('checklistAnswers'),
  checklistAnswerInvitations: entityReducer('checklistAnswerInvitations'),
  contacts: entityReducer('contacts'),
  applications: entityReducer('applications')
};